/**
 * L'inglese.
 *
 * Chiave: la frase italiana, esattamente com'è scritta nel codice. Valore: la
 * frase inglese. Quello che manca resta in italiano, che è brutto ma si legge;
 * `pnpm testi` dice cosa manca e cosa è avanzato.
 *
 * Non è una traduzione parola per parola: è la stessa cosa detta come la
 * direbbe chi lavora in un ufficio export americano. «Merce pronta per la
 * spedizione» è «Goods ready to be shipped» perché è già così che si chiama
 * in Business Central, non «Merchandise ready».
 */

export const EN: Record<string, string> = {
  ' — lascia vuoto per non cambiarla': ' — leave empty to keep it',
  'Accesso al programma': 'Access to the application',
  'Almeno otto caratteri.': 'At least eight characters.',
  'Cambia la password': 'Change the password',
  'Cambiando la password a {nome} si chiudono anche le sue sessioni aperte, e gli arriva un messaggio.': 'Changing {nome}’s password also closes their open sessions, and they get an e-mail.',
  'Password dimenticata?': 'Forgot your password?',
  'Indirizzo e-mail con cui entra': 'E-mail address they sign in with',
  'La password è cambiata. Adesso puoi entrare.': 'The password has been changed. You can sign in now.',
  'La password è cambiata. Ti è arrivato anche un messaggio che lo conferma.': 'The password has been changed. You have also been sent an e-mail confirming it.',
  'La posta non è configurata, quindi il messaggio non è partito. Il link è questo:': 'Mail is not configured, so nothing was sent. Here is the link:',
  'Cambiarla non butta fuori le altre sessioni aperte: per quelle c’è «Sessioni aperte». Si chiudono da sole solo se la password la rifà un amministratore, o se la ripristini dal link.':
    'Changing it does not sign out your other open sessions: for those there is «Open sessions». They only close on their own if an administrator resets the password, or if you restore it from the link.',
  'Le due password non coincidono.': 'The two passwords do not match.',
  'Mandami il link': 'Send me the link',
  'Non entra più, ma resta tutto quello che ha fatto': 'They can no longer sign in, but everything they did stays',
  'non è mai entrato': 'has never signed in',
  'Password di adesso': 'Current password',
  'Password nuova': 'New password',
  'Questo link non è completo: rifai la richiesta di ripristino.': 'This link is incomplete: ask for the reset again.',
  'Questo operatore non ha ancora l’accesso. Scrivi indirizzo e password e li avrà.': 'This operator has no access yet. Type an address and a password and they will have it.',
  'Riattiva l’utenza': 'Reactivate the account',
  Ripetila: 'Repeat it',
  'Salva l’accesso': 'Save the access',
  'Scegli la password nuova': 'Choose a new password',
  'Scrivi l’indirizzo con cui entri: ti arriva un messaggio con il link per rifare la password.': 'Type the address you sign in with: you will get an e-mail with the link to set a new password.',
  'Sospendi l’utenza': 'Suspend the account',
  sospesa: 'suspended',
  'Torna a poter entrare': 'Can sign in again',
  'ultimo accesso': 'last sign-in',
  'Vai all’accesso': 'Go to sign in',
  '← Torna all’accesso': '← Back to sign in',
  ' — cambia': ' — changes',
  'Case pack': 'Case pack',
  Conferma: 'Confirm',
  'Confezioni per pallet': 'Packs per pallet',
  'Cosa verrebbe?': 'What would come out?',
  'Dagli attributi verrebbe': 'From the attributes it would be',
  'dati del CRM: Business Central non li ha': 'CRM data: Business Central does not have it',
  'Formato confezione (gr)': 'Pack size (g)',
  'Formato confezione (oz)': 'Pack size (oz)',
  'Formato lordo (gr)': 'Gross size (g)',
  Genera: 'Generate',
  'Ho capito': 'Got it',
  'manda anche quelli che non sono allo stato 3': 'send the ones that are not at state 3 too',
  'Mando al vettore gli ordini selezionati?': 'Send the selected orders to the carrier?',
  Nascondi: 'Hide',
  'Pedane per container': 'Platforms per container',
  'Porto allo stato 2 gli ordini selezionati che sono allo stato 1?': 'Move the selected orders that are at state 1 to state 2?',
  'Questo codice ce l’ha già qualcun altro:': 'Someone else already has this code:',
  'Rifà i quattro GTIN-14 e lascia stare GTIN-12 e GTIN-13': 'Redoes the four GTIN-14s and leaves GTIN-12 and GTIN-13 alone',
  'Rigenera tutti': 'Regenerate all',
  'SKU e descrizione arrivano da Business Central': 'SKU and description come from Business Central',
  'Solo i GTIN-14': 'GTIN-14 only',
  'Stato 2': 'State 2',
  'Unità di misura': 'Unit of measurement',
  'usa questo': 'use this',
  // ————————————————————————————————————————————————— telaio e menu
  'Il mio lavoro': 'My work',
  Anagrafiche: 'Records',
  Clienti: 'Customers',
  Fornitori: 'Suppliers',
  Agenti: 'Agents',
  Lead: 'Leads',
  Prospect: 'Prospects',
  Operatori: 'Users',
  Prodotti: 'Products',
  Articoli: 'Items',
  Listini: 'Price lists',
  Trattative: 'Deals',
  Contabilità: 'Accounting',
  'Ordini di vendita': 'Sales orders',
  Documentazione: 'Documents',
  Documenti: 'Documents',
  Impostazioni: 'Settings',
  'Dati generici': 'Reference data',
  Integrazioni: 'Integrations',
  Profilo: 'Profile',
  Avvisi: 'Alerts',
  Esci: 'Sign out',
  'Esco…': 'Signing out…',
  'Apri il menu': 'Open the menu',
  'Chiudi il menu': 'Close the menu',
  'Cerca ordini, clienti, articoli': 'Search orders, customers, items',
  'Cerco…': 'Searching…',
  'Vedi tutti ({n})': 'See all ({n})',
  'prot.': 'ref.',
  'Lavora in': 'Working in',
  'Nessuna azienda': 'No company',
  Aspetto: 'Appearance',
  Lingua: 'Language',
  Italiano: 'Italian',
  Inglese: 'English',
  'La scelta resta sul tuo profilo. Cambiare lingua ricarica la pagina.':
    'The choice stays on your profile. Changing the language reloads the page.',
  'Profilo e password': 'Profile and password',
  Parametri: 'Settings',

  // ———————————————————————————————————————————————————————— i parametri
  'Codici a barre GS1': 'GS1 barcodes',
  'Prefisso US': 'US prefix',
  'Prefisso EU': 'EU prefix',
  'Solo cifre. Entra nel GTIN-12 e nei due GTIN-14 americani.':
    'Digits only. It goes into the GTIN-12 and into the two American GTIN-14s.',
  'Solo cifre. Entra nel GTIN-13 e nei due GTIN-14 europei.':
    'Digits only. It goes into the GTIN-13 and into the two European GTIN-14s.',
  'Cambiarli non tocca i codici già generati: valgono per quelli che si generano da adesso in poi. Senza questi due prefissi la generazione dei codici non parte affatto.':
    'Changing them does not touch the codes already generated: they apply to the ones generated from now on. Without these two prefixes, code generation does not start at all.',
  'Esportazione CSV': 'CSV export',
  Separatore: 'Separator',
  'Punto e virgola': 'Semicolon',
  Virgola: 'Comma',
  'Vale per tutte le esportazioni CSV degli elenchi. I file Excel non cambiano.':
    'It applies to every CSV export of the lists. Excel files do not change.',
  'Excel apre il file secondo le impostazioni del computer che lo apre: a Scafati va il punto e virgola, a Edison la virgola. Il v2 esporta con la virgola per tutte e due le società.':
    'Excel opens the file according to the settings of the computer opening it: in Scafati the semicolon works, in Edison the comma. The current system exports with the comma for both companies.',
  'Import da Business Central': 'Import from Business Central',
  'Prefissi degli articoli da accettare': 'Item code prefixes to accept',
  'Separati da virgola. In Business Central gli articoli sono molti di più — semilavorati, imballi — e senza questo filtro entrerebbero tutti.':
    'Comma separated. In Business Central there are many more items — semi-finished goods, packaging — and without this filter they would all come in.',
  'Sezionale dei clienti creati dall’import': 'Sectional for customers created by the import',
  'Valuta dei clienti creati dall’import': 'Currency for customers created by the import',
  'Sezionale e valuta si mettono solo ai clienti che l’import crea da zero: a chi c’è già non si tocca niente.':
    'Sectional and currency are only applied to customers the import creates from scratch: nothing is touched on those that already exist.',
  'Quello che non sta più qui': 'What is no longer here',
  'Nel programma di oggi questa pagina ha 78 voci, e quasi tutte sono nomi, chiavi e indirizzi dei collegamenti verso Business Central, i vettori e l’archivio dei file. Nella 3.0 sono configurazione del servizio: una password non sta in una tabella che si esporta, e cambiarla non deve essere una cosa che si fa per sbaglio da una maschera.':
    'In the current application this page has 78 entries, and nearly all of them are names, keys and addresses of the connections to Business Central, the carriers and the file archive. In 3.0 they are service configuration: a password does not belong in a table that gets exported, and changing one should not be something you can do by mistake from a form.',
  'Questa pagina non è per te': 'This page is not for you',
  'Non è stato possibile aprire i parametri.': 'The settings could not be opened.',

  // ————————————————————————————————————————————— convertire un'anagrafica
  Converti: 'Convert',
  'Converti l’anagrafica': 'Convert the record',
  'Converto…': 'Converting…',
  'Adesso è': 'It is now a',
  'Diventa:': 'It becomes:',
  'Cambia il tipo, e con quello l’elenco in cui si trova. Tutto il resto — indirizzi, contatti, ordini, storico — resta attaccato dov’è.':
    'It changes the type, and with it the list the record lives in. Everything else — addresses, contacts, orders, history — stays where it is.',

  // ————————————————————————————————————————————————————————————— il profilo
  'Chi sono': 'Who I am',
  Nome: 'Name',
  'Indirizzo con cui entro': 'Address I sign in with',
  'Livello di accesso': 'Access level',
  'Aziende in cui lavoro': 'Companies I work in',
  'Il nome e l’indirizzo si cambiano dalla scheda dell’operatore.':
    'The name and the address are changed from the user’s record.',
  'Apri la mia scheda': 'Open my record',
  'Come si vede il programma': 'How the application looks',
  'Cambiare lingua ricarica la pagina.': 'Changing the language reloads the page.',
  'Da dove comincio quando entro': 'Where I start from when I sign in',
  'Vale dal prossimo accesso, e ogni volta che si riapre il programma.':
    'It applies from the next sign-in, and every time the application is reopened.',
  'Sessioni aperte': 'Open sessions',
  questa: 'this one',
  'Esci dagli altri dispositivi': 'Sign out from the other devices',
  'Chiudo…': 'Closing…',
  'Non c’era nessun’altra sessione aperta.': 'There was no other open session.',
  'Chiuse {quante} sessioni. Questa resta aperta.':
    'Closed {quante} sessions. This one stays open.',
  'Ultimi accessi': 'Latest sign-ins',
  'Nessun accesso registrato.': 'No sign-in recorded.',
  'Se qui c’è un accesso che non hai fatto tu, cambia subito la password e dillo a un amministratore.':
    'If there is a sign-in here that was not yours, change the password right away and tell an administrator.',

  // ————————————————————————————————————————————————— parole di tutti i giorni
  'Un momento…': 'One moment…',
  'Elenco non disponibile': 'List not available',
  'Scegli…': 'Choose…',
  Annulla: 'Cancel',
  Salva: 'Save',
  'Salvo…': 'Saving…',
  Modifica: 'Edit',
  Elimina: 'Delete',
  Chiudi: 'Close',
  Cambia: 'Change',
  Togli: 'Remove',
  Duplica: 'Duplicate',
  Avanti: 'Next',
  Indietro: 'Back',
  Nuovo: 'New',
  Cerca: 'Search',
  'Confermi?': 'Are you sure?',
  'Nessun risultato.': 'No results.',
  'Scrivi almeno due lettere': 'Type at least two letters',
  'Vai agli ordini': 'Go to orders',
  archiviato: 'archived',
  'Mostra archiviati': 'Show archived',
  '+ Filtro': '+ Filter',
  '+ Salva questa vista': '+ Save this view',
  Ordine: 'Order',
  Ordini: 'Orders',
  Data: 'Date',
  Cliente: 'Customer',
  Destinazione: 'Destination',
  Stato: 'State',
  'Nave / container': 'Vessel / container',
  Arrivo: 'Arrival',
  Totale: 'Total',
  Pagamento: 'Payment',
  Quantità: 'Quantity',
  Articolo: 'Item',
  Codice: 'Code',
  Descrizione: 'Description',
  Annotazioni: 'Notes',
  Riga: 'Row',
  Righe: 'Lines',
  Categorie: 'Categories',
  File: 'File',
  Titolo: 'Title',
  Sezionale: 'Series',
  'Numero d’ordine del cliente': 'Customer order number',
  'Data dell’ordine': 'Order date',
  'Consegna richiesta': 'Requested delivery',
  'Destinazione della merce': 'Ship-to address',
  'Tipo di pagamento': 'Payment terms',
  Banca: 'Bank',
  'Quello del cliente': 'The customer’s',
  'Quella del cliente': 'The customer’s',
  'Prima scegli il cliente': 'Choose the customer first',

  // ————————————————————————————————————————————————— elenco ordini
  'Nuovo ordine': 'New order',
  'Importa da Excel': 'Import from Excel',
  Tutti: 'All',
  '{n} ordini': '{n} orders',
  '{n} ordini, archiviati compresi': '{n} orders, archived included',
  'Cerca per PO#, cliente, fattura, container': 'Search by PO#, customer, invoice, container',
  'Più PO# insieme: incollali separati da virgole, spazi o a capo':
    'Several PO# at once: paste them separated by commas, spaces or line breaks',
  '{n} PO# cercati: trovati tutti.': '{n} PO# searched: all found.',
  '{n} PO# cercati. Non trovati: {elenco}': '{n} PO# searched. Not found: {elenco}',
  '{n} PO# cercati: tutti hanno documenti.': '{n} PO# searched: all have documents.',
  '{n} PO# cercati. Senza documenti: {elenco}': '{n} PO# searched. No documents: {elenco}',
  'Stima del vettore': 'Carrier estimate',
  'Arrivo confermato': 'Confirmed arrival',
  'Il cliente la chiedeva per il {data}': 'The customer asked for it by {data}',
  'Vista tua': 'Your view',
  'Condivisa da un collega': 'Shared by a colleague',

  // ————————————————————————————————————————————————— scheda ordine
  'Avanza di stato': 'Move to next state',
  'Correggi lo stato': 'Correct the state',
  'Invia al vettore': 'Send to carrier',
  'Duplica l’ordine': 'Duplicate the order',
  PDF: 'PDF',
  'nessun PDF': 'no PDF',
  Carica: 'Upload',
  Stacca: 'Detach',
  'La fattura si carica in PDF.': 'The invoice must be a PDF.',
  'Duplico…': 'Duplicating…',
  'Le copie nascono nel primo stato, con un protocollo nuovo. Fatture, navi, container e date della spedizione non si copiano: sono di questo ordine, non del prossimo.':
    'The copies start in the first state, with a new protocol number. Invoices, vessels, containers and shipping dates are not copied: they belong to this order, not to the next one.',
  'Quante copie': 'How many copies',
  'Le righe': 'The lines',
  'copia anche le {n} righe': 'copy the {n} lines too',
  'questo ordine non ha righe': 'this order has no lines',
  'I numeri delle copie': 'The numbers for the copies',
  'contali avanti da questo': 'count on from this one',
  'li detto io': 'I will type them',
  'Parte fissa da lasciar stare': 'Fixed part to leave alone',
  'vuoto, se il numero è tutto cifre': 'empty, if the number is all digits',
  'Da «{numero}» non si sa contare avanti: indica la parte fissa, oppure detta i numeri.':
    'There is no counting on from “{numero}”: give the fixed part, or type the numbers.',
  'I numeri, separati da una virgola': 'The numbers, separated by a comma',
  'Ne hai dettati {dettati} e ne servono {servono}.':
    'You typed {dettati} and {servono} are needed.',
  Verranno: 'They will be',
  'e altri {n}': 'and {n} more',
  'Fai la copia': 'Make the copy',
  'Fai {n} copie': 'Make {n} copies',
  'Invio…': 'Sending…',
  'Mandato, e il vettore ha risposto.': 'Sent, and the carrier answered.',
  'Mandato, e il vettore ha risposto con': 'Sent, and the carrier answered with',
  'righe.': 'rows.',
  'Mandato al vettore.': 'Sent to the carrier.',
  'Mandato al vettore, file': 'Sent to the carrier, file',
  'Nessun allegato su questo ordine.': 'No attachments on this order.',
  'Titolo (senza, vale il nome del file)': 'Title (without it, the file name is used)',
  Attacca: 'Attach',
  'Carico…': 'Uploading…',
  'Togli davvero': 'Remove for good',
  'file non trovato': 'file not found',
  'Mandato: il vettore non ha novità.': 'Sent: the carrier has nothing new.',
  'Non è stato possibile mandarlo.': 'It could not be sent.',
  'Mandalo lo stesso': 'Send it anyway',
  'Lascia stare': 'Leave it',
  'Ho letto': 'Got it',
  'Dati principali': 'Details',
  Spedizione: 'Shipping',

  // ————————————————————————————————————————————————— importazione da Excel
  'Importa ordini da Excel': 'Import orders from Excel',
  'Prima di tutto: di chi è questo foglio': 'First of all: whose sheet is this?',
  'Di chi è questo foglio': 'Whose sheet is this?',
  Foglio: 'Sheet',
  Colonne: 'Columns',
  Anteprima: 'Preview',
  'Quale foglio': 'Which sheet',
  'Quale colonna è cosa': 'Which column is what',
  'Il foglio da importare': 'The sheet to import',
  'Leggi il file': 'Read the file',
  'Leggo il file…': 'Reading the file…',
  'Guarda cosa succede': 'See what happens',
  'Controllo il foglio…': 'Checking the sheet…',
  'Ricontrolla il foglio': 'Check the sheet again',
  'Ricontrollo…': 'Checking again…',
  'Dove va questa merce?': 'Where do these goods go?',
  'Prezzi diversi dal listino': 'Prices that differ from the price list',
  'Prima dimmi dove va la merce': 'First tell me where the goods go',
  'Prima dimmi cosa fare dei PO di altri clienti':
    'First tell me what to do with the POs of other customers',
  'Aggiorna {n} consegne': 'Update {n} delivery dates',
  'Aggiorna 1 consegna': 'Update 1 delivery date',
  'file non in archivio': 'file missing from the archive',
  'Entra': 'Sign in',
  'GTIN-12 e GTIN-13 ci sono già e verranno sostituiti. Se sono codici comprati, usa «Solo i GTIN-14». Rigenero tutti?': 'GTIN-12 and GTIN-13 already exist and will be replaced. If they are purchased codes, use «GTIN-14 only». Regenerate all?',
  'Almeno 8 caratteri.': 'At least 8 characters.',
  'Ci sono modifiche non salvate: le perdo e vado avanti?': 'There are unsaved changes: discard them and leave?',
  'Chiudo senza salvare? Quello che hai scritto si perde.': 'Close without saving? What you typed will be lost.',
  'Gli avvisi non sono arrivati: riprova fra un momento.': 'The alerts did not load: try again in a moment.',
  'PO che sono già di un altro cliente': 'POs that already belong to another customer',
  '{n} da decidere': '{n} to decide',
  'Questi numeri d’ordine ci sono già, ma non sono di {cliente}. Il foglio ne cambierebbe la consegna richiesta: dimmi cosa fare.':
    'These order numbers already exist, but they are not {cliente}’s. The sheet would change their requested delivery: tell me what to do.',
  'è di {cliente}{codice} · ordine del {data}{stato} · consegna richiesta {prima}, nel foglio {dopo}':
    'belongs to {cliente}{codice} · order of {data}{stato} · requested delivery {prima}, in the sheet {dopo}',
  'Lascia stare quell’ordine': 'Leave that order alone',
  'Aggiorna la sua consegna al {data}': 'Update its delivery to {data}',
  'consegne da aggiornare': 'delivery dates to update',
  'Importo…': 'Importing…',
  'Importazione finita': 'Import finished',
  'Ordini creati': 'Orders created',
  'Cosa è rimasto fuori': 'What was left out',
  'Importane un altro': 'Import another one',
  'Nessun ordine è stato creato.': 'No order was created.',
  'righe lette': 'rows read',
  'ordini da creare': 'orders to create',
  'già presenti': 'already there',
  'righe che non entrano': 'rows that cannot go in',
  'righe da guardare': 'rows to look at',
  'Riga dei titoli': 'Header row',
  'Nel foglio': 'In the sheet',
  'Nel listino': 'In the price list',
  Differenza: 'Difference',
  'Scegli la destinazione…': 'Choose the destination…',
  'non sembra da importare': 'does not look importable',
  proposto: 'suggested',
  'come l’ultima volta': 'same as last time',
  'Cosa non va': 'What is wrong',
  'Prezzo del listino': 'Price list price',
  'c’è già': 'already there',

  // ————————————————————————————————————————————————— avvisi
  'Posta in uscita': 'Outbox',
  Modelli: 'Templates',
  'Che cosa': 'What',
  'Arrivo previsto': 'Expected arrival',
  Rivisto: 'Revised',
  Notificato: 'Notified',
  'una volta': 'once',
  '{n} volte': '{n} times',
  'Nessun avviso aperto.': 'No open alerts.',
  '{n} avvisi aperti': '{n} open alerts',
  // ————————————————————————————————————————————————— elenchi, filtri, piede
  'Righe per pagina': 'Rows per page',
  'Nessun risultato': 'No results',
  'Aggiungi un filtro': 'Add a filter',
  'Cambia questo filtro': 'Change this filter',
  'Togli il filtro': 'Remove the filter',
  'Con gli archiviati': 'Archived included',
  'Nome della vista': 'View name',
  'Seleziona la riga': 'Select the row',
  'Seleziona tutte le righe della pagina': 'Select every row on this page',
  'Escono dagli elenchi e dalle ricerche. Quello che ci sta attaccato — righe, documenti, storico — resta dov’è.':
    'They drop out of lists and searches. What hangs off them — lines, documents, history — stays where it is.',
  ordini: 'orders',
  Tutte: 'All',
  Nessuna: 'None',
  'sì': 'yes',
  'Non impostata': 'Not set',
  'Non impostato': 'Not set',
  'Non specificato': 'Not specified',
  Quando: 'When',

  // ————————————————————————————————————————————————— ordini
  'Nessun ordine con questi filtri.': 'No orders match these filters.',
  'Nessun ordine per «{cercato}».': 'No orders for “{cercato}”.',
  'Togli «{stato}» dal filtro': 'Remove “{stato}” from the filter',
  '{stato} — aggiungilo al filtro, si possono tenere più stati insieme':
    '{stato} — add it to the filter, several states can be kept together',
  'Ordine non disponibile': 'Order not available',
  'Questo cliente non ha ordini.': 'This customer has no orders.',
  'Vedi gli ordini →': 'See the orders →',
  'Togli questo ordine': 'Remove this order',
  'Questo ordine non ha ancora righe: aggiungine una. Senza articoli non può avanzare di stato.':
    'This order has no lines yet: add one. Without items it cannot move to the next state.',
  'Questo ordine è arrivato in fondo: non c’è nessuno stato dopo.':
    'This order has reached the end: there is no state after this one.',
  'Questo stato è stato saltato': 'This state was skipped',
  'Perché lo stai correggendo': 'Why you are correcting it',
  'Es. il cliente ha chiesto di rifare i passaggi: la merce non era pronta':
    'E.g. the customer asked to redo the steps: the goods were not ready',
  'Serve a rimettere a posto passaggi fatti male. Non segue le regole di avanzamento — le scavalca — quindi resta scritto nello storico con il motivo e con chi l’ha fatto.':
    'It is there to put badly done steps right. It does not follow the forward rules — it overrides them — so it stays in the history with the reason and with who did it.',
  'Resta nello storico dell’ordine, insieme al tuo nome.':
    'It stays in the order history, together with your name.',
  'Storico delle modifiche': 'Change history',
  'Nessuna modifica registrata.': 'No changes recorded.',
  'Nessuna nave assegnata a questo ordine.': 'No vessel assigned to this order.',
  'Date del viaggio': 'Voyage dates',
  'Riferimento del cliente': 'Customer reference',
  'Quanto è stato ordinato': 'How much was ordered',
  'Totale della riga:': 'Line total:',
  'Listino da cui prendere il prezzo': 'Price list to take the price from',
  'Aggiungi un articolo all’ordine': 'Add an item to the order',
  'Scrivi per restringere l’elenco': 'Type to narrow the list',
  'Solo gli articoli del listino scelto. Per cercare in tutto il catalogo, scegli «Nessuno — prezzo a mano».':
    'Only the items on the chosen price list. To search the whole catalogue, choose “None — price by hand”.',
  'Nessun articolo del listino per «{cerca}».': 'No items on the price list for “{cerca}”.',
  'Questo listino non ha articoli.': 'This price list has no items.',
  'Altri {n}: scrivi per restringere.': '{n} more: type to narrow the list.',
  'Questo cliente non ha listini: il prezzo si scrive a mano.':
    'This customer has no price lists: type the price by hand.',
  'Questo articolo non è in quel listino: scrivi il prezzo a mano.':
    'This item is not on that price list: type the price by hand.',
  'Prezzo specifico della destinazione': 'Price specific to the destination',
  'Quella della riga': 'The line’s',

  // ————————————————————————————————————————————————— anagrafiche
  'Anagrafica non disponibile': 'Record not available',
  'Città': 'City',
  'Clienti di questa azienda': 'Customers of this company',
  'Le persone con cui si parla in questa azienda': 'The people you talk to at this company',
  'Nessun contatto. Aggiungine uno per tenere i recapiti delle persone.':
    'No contacts. Add one to keep people’s details.',
  'Nessun indirizzo. Aggiungine uno per poter spedire.': 'No addresses. Add one so you can ship.',
  'Nessun recapito per questa persona.': 'No details for this person.',
  'Nessun indirizzo e-mail.': 'No e-mail address.',
  'Nessun numero di telefono.': 'No phone number.',
  'Nessun sito web.': 'No website.',
  'Indirizzo del sito': 'Website address',
  'Indirizzo principale — è quello che compare in elenco e nelle stampe':
    'Main address — the one that shows in lists and on printouts',
  'Recapito predefinito — è quello che si usa per primo': 'Default contact — the one used first',
  'Le destinazioni finiscono negli ordini e viaggiano verso Business Central':
    'Destinations end up on orders and travel to Business Central',
  'Forse è un indirizzo vecchio': 'It may be an old address',
  'Scegli il paese…': 'Choose the country…',
  'Riceve gli avvisi': 'Receives alerts',
  'Le mail partono da sole quando succede: chi non è spuntato qui non riceve niente.':
    'The e-mails go out on their own when it happens: anyone not ticked here gets nothing.',
  'Ritardi sull’arrivo — quando il vettore sposta l’ETA di oltre sette giorni':
    'Arrival delays — when the carrier moves the ETA by more than seven days',
  'Cerca per nome, codice BC o partita IVA': 'Search by name, BC code or VAT number',

  // ————————————————————————————————————————————————— articoli
  'Articolo non disponibile': 'Item not available',
  'Cerca per SKU, descrizione, numero BC o codice GS1':
    'Search by SKU, description, BC number or GS1 code',
  'Cerca per descrizione, SKU o numero BC': 'Search by description, SKU or BC number',
  'Cartoni per pallet': 'Cases per pallet',
  'Dimensioni unità': 'Unit size',
  'Misura unità': 'Unit of measure',
  'Peso unità': 'Unit weight',
  '— il codice con cui lo chiama lui': '— the code they call it by',

  // ————————————————————————————————————————————————— listini
  'Scarica il listino in Excel, con i prezzi per destinazione':
    'Download the price list in Excel, with the per-destination prices',
  'Listino non disponibile': 'Price list not available',
  'Nome del listino': 'Price list name',
  'Nome del nuovo listino': 'Name of the new price list',
  'Valido dal': 'Valid from',
  'Valido fino al': 'Valid until',
  'Valida dal': 'Valid from',
  'Valida al': 'Valid until',
  'Per destinazione': 'Per destination',
  'Prezzi per destinazione': 'Prices per destination',
  'Prezzi dedicati a una destinazione': 'Prices dedicated to one destination',
  'sostituiscono il prezzo qui sopra, per quell’indirizzo':
    'they replace the price above, for that address',
  'Nessuno: vale il prezzo di riga per tutte le destinazioni.':
    'None: the line price applies to every destination.',
  'Questo listino non ha ancora articoli: aggiungine uno, o duplica un listino che li ha già.':
    'This price list has no items yet: add one, or duplicate a list that already has them.',
  'Si copiano tutte le righe, i prezzi per destinazione, gli sconti e le aliquote. I prezzi restano quelli di partenza: è da lì che si corregge.':
    'Every line is copied, with destination prices, discounts and tax rates. Prices stay as they were: that is where you start correcting.',
  'Cambia il prezzo': 'Change the price',
  '— se vale per tutto un paese': '— if it applies to a whole country',
  'già a listino': 'already on the list',

  // ————————————————————————————————————————————————— trattative
  'Trattativa non trovata': 'Deal not found',
  'La trattativa': 'The deal',
  'Dati e attività': 'Details and activity',
  'Attività': 'Activity',
  'Tipo di attività': 'Activity type',
  'Registra un’attività': 'Record an activity',
  'Esigenze del cliente': 'What the customer needs',
  'Probabilità': 'Probability',
  'Probabilità di chiusura:': 'Probability of closing:',
  ' — budget per la probabilità': ' — budget times probability',
  'Data della proposta': 'Proposal date',
  'Titolo della proposta': 'Proposal title',
  'Documenti della trattativa': 'Deal documents',
  'Cerca per oggetto, cliente, esigenze, note': 'Search by subject, customer, needs, notes',
  'Ancora niente. La prima telefonata, la prima e-mail: è la storia della trattativa, e serve a chi la riprende in mano fra un mese.':
    'Nothing yet. The first call, the first e-mail: it is the story of the deal, and it is what helps whoever picks it up a month from now.',
  'Nessuna proposta. Una proposta è un listino che non è ancora ufficiale: quando viene approvata si trasforma in un listino vero.':
    'No proposals. A proposal is a price list that is not official yet: once approved it turns into a real one.',
  'Nessun articolo. Una proposta senza prezzi non si può mandare in approvazione.':
    'No items. A proposal without prices cannot be sent for approval.',
  'I prezzi si aggiungono dopo aver salvato la proposta.':
    'Prices are added after the proposal is saved.',
  'Togli dalla proposta': 'Remove from the proposal',
  'Vengono portati nel listino ufficiale insieme al resto.':
    'They are carried into the official price list with everything else.',
  '. I prezzi sono in vigore: gli ordini di questo cliente li trovano da soli.':
    '. The prices are in force: this customer’s orders find them on their own.',

  // ————————————————————————————————————————————————— documenti
  'Documento non trovato': 'Document not found',
  'Dati del documento': 'Document details',
  'Descrizione del documento — «Visura camerale cliente»':
    'What the document is — “Customer company registration”',
  'Questo documento non ha ancora un file.': 'This document has no file yet.',
  'Il documento dice di avere il file': 'The document says it has the file',
  ', ma nell’archivio non c’è. Ricaricalo qui sotto.':
    ', but it is not in the archive. Upload it again below.',
  'Il file': 'The file',
  '— caricato una volta sola.': '— uploaded once only.',
  'Il file si carica una volta sola: nasce un documento per ogni ordine, tutti sullo stesso file.':
    'The file is uploaded once only: one document is created per order, all on the same file.',
  ', tutti sul file': ', all on the file',
  'Trascina qui il file, o fai clic per sceglierlo': 'Drag the file here, or click to choose it',
  'Nessuna categoria definita per questa azienda: si creano dai Dati generici.':
    'No categories defined for this company: they are created under Reference data.',

  // ————————————————————————————————————————————————— import excel
  // la frase è spezzata in tre perché in mezzo c'è un «suo» in grassetto: le
  // due metà vanno tradotte in modo che si ricuciano con quello nel mezzo
  'Il cliente si sceglie per primo perché decide tutto il resto: i codici articolo del foglio si cercano nel':
    'The customer comes first because everything else follows from it: the item codes in the sheet are looked up in',
  'listino, e da lì vengono i prezzi. Il prezzo scritto nell’Excel serve solo a controllare.':
    'price list, and that is where the prices come from. The price written in the Excel is only there to check against.',
  'Vale per tutti gli ordini di questo foglio.': 'It applies to every order in this sheet.',
  'Il file resta qui finché non hai finito: cambiare foglio o colonna non lo ricarica.':
    'The file stays here until you are done: changing sheet or column does not upload it again.',
  'Quasi sempre la prima. Cambiala se in cima al foglio c’è un titolo o una riga vuota.':
    'Almost always the first one. Change it if there is a heading or a blank row at the top of the sheet.',
  'Ricorda queste colonne per': 'Remember these columns for',
  'Ricorda queste colonne per questo cliente': 'Remember these columns for this customer',
  ': la prossima volta le ritrovi compilate.': ': next time you find them already filled in.',
  'La differenza è quanto il listino sta sopra — o sotto — il foglio. Gli ordini entrano col prezzo del listino: se quello giusto è l’altro, il listino va corretto prima di importare.':
    'The difference is how far the price list sits above — or below — the sheet. Orders go in at the price list price: if the other one is right, fix the price list before importing.',

  // ————————————————————————————————————————————————— avvisi e integrazioni
  'La posta non è ancora collegata: i messaggi vengono composti e registrati qui, ma non partono. Serve la chiave di Resend.':
    'Mail is not connected yet: messages are composed and recorded here, but they do not go out. The Resend key is needed.',
  'Nessun messaggio ancora.': 'No messages yet.',
  'Nessuna esecuzione ancora.': 'No runs yet.',
  'Articoli, clienti e destinazioni arrivano da Business Central. Qui si vede se arrivano davvero.':
    'Items, customers and destinations come from Business Central. Here you can see whether they actually arrive.',

  // ————————————————————————————————————————————————— dati generici, accesso, fuori strada
  'Le anagrafiche di supporto: quello che riempie i menu del resto del programma.':
    'The supporting records: what fills the menus everywhere else.',
  'Con quale azienda lavori?': 'Which company are you working with?',
  'Ciao {nome}, puoi cambiarla quando vuoi.': 'Hi {nome}, you can switch whenever you like.',
  'Non sei tu?': 'Not you?',
  'Accedi al CRM': 'Sign in to the CRM',
  'Inserisci e-mail e password per continuare.': 'Enter your e-mail address and password to continue.',
  'Mostra la password': 'Show password',
  'Nascondi la password': 'Hide password',
  'Le maiuscole sono bloccate.': 'Caps Lock is on.',
  'Controlla la posta': 'Check your e-mail',
  'Link incompleto': 'Incomplete link',
  'Password cambiata': 'Password changed',
  'Si entra con le stesse credenziali di oggi: al passaggio alla 3.0 nessuno deve reimpostare la password.':
    'You sign in with the same credentials as today: nobody has to reset their password when moving to 3.0.',
  'Questa sezione non è ancora stata costruita': 'This section has not been built yet',
  'Questo indirizzo non esiste': 'This address does not exist',
  'I percorsi delle pagine sono cambiati:': 'The page paths have changed:',
  '. Se hai un collegamento salvato, aggiornalo.': '. If you have a saved link, update it.',
  'oppure scegli una voce dal menu.': 'or pick something from the menu.',
  'Torna al mio lavoro': 'Back to my work',

  // le sezioni che un livello di accesso non apre
  'Questa sezione non è fra le tue': 'This section is not one of yours',
  'Dipende dal tuo livello di accesso': 'It depends on your access level',
  'Ogni livello vede le sue voci del menu. Se questa ti serve per lavorare, chiedi a un amministratore di cambiarti il livello.':
    'Each level sees its own menu items. If you need this one for your work, ask an administrator to change your level.',
  'Per cambiarli chiedi a un amministratore.': 'To change them, ask an administrator.',
  'Le proposte in corso': 'Proposals in progress',
  'Arriva più avanti': 'Coming later on',
  // ————————————————————————————————————————————————— creare a mano
  Crea: 'Create',
  'Creo…': 'Creating…',
  'Nuovo articolo': 'New item',
  articoli: 'items',
  'Codice fiscale': 'Tax code',
  'Esiste già:': 'Already there:',
  'Puoi crearne un’altra lo stesso, se è una sede diversa.':
    'You can still create another one, if it is a different site.',
  'Lascialo vuoto se in BC non c’è ancora.': 'Leave it empty if it is not in BC yet.',
  'Indirizzi, contatti e recapiti si aggiungono dopo, dalla scheda: appena creata si apre da sola.':
    'Addresses, contacts and details are added afterwards, from the record itself: it opens on its own as soon as it is created.',
  'Formati, pesi, imballo e codici GS1 si compilano dopo, dalla scheda: appena creato si apre da sola.':
    'Sizes, weights, packing and GS1 codes are filled in afterwards, from the item itself: it opens on its own as soon as it is created.',
  'È la chiave dell’articolo: senza, gli aggiornamenti da Business Central non lo troveranno.':
    'It is the item’s key: without it, updates from Business Central will not find it.',
  'Senza numero di Business Central l’articolo resta solo qui: si può mettere in un listino e in un ordine, ma l’importazione da BC non lo riconoscerà. Il numero di Business Central nella scheda non si cambia: se l’articolo c’è già in BC, scrivilo adesso.':
    'With no Business Central number the item stays here only: it can go on a price list and on an order, but the import from BC will not recognise it. The Business Central number cannot be changed on the item: if the item is already in BC, type it now.',
  // ————————————————————————————————————————————————— le ultime, con l'apostrofo
  'A che punto siamo': 'Where we are',
  'Dove si passa la giornata': 'Where the day is spent',
  'Fatture, DDT, prove di consegna': 'Invoices, delivery notes, proofs of delivery',
  'Le date d’arrivo che si sono spostate': 'The arrival dates that have moved',
  'Il CRM 3.0 ha preso il posto del vecchio. Tutto quello che sta nel menu lavora sui dati veri, portati dal vecchio CRM: anagrafiche, articoli, listini, ordini, documenti con i loro file, trattative, avvisi e vettori.':
    'CRM 3.0 has replaced the old one. Everything in the menu works on the real data, carried over from the old CRM: records, items, price lists, orders, documents with their files, deals, alerts and carriers.',
  'Se qualcosa non torna rispetto al vecchio CRM, segnalatelo subito: si corregge in giornata.':
    'If something does not match the old CRM, let us know straight away: it gets fixed the same day.',
  "Gli allegati si aggiungono dopo aver salvato: il file ha bisogno di un'attività a cui attaccarsi.":
    'Attachments are added after saving: the file needs an activity to attach to.',
  "I limiti di lunghezza sono quelli di Business Central: se li superi, l'ordine viene rifiutato al momento dell'invio.":
    'The length limits are Business Central’s: go over them and the order is rejected when it is sent.',
  "L'ordine nasce vuoto nel primo stato: gli articoli si aggiungono dopo, dalla sua scheda.":
    'The order starts empty in the first state: items are added afterwards, from the order itself.',
  "Nessun documento. Qui vanno le carte della trattativa — visure, capitolati, bozze — che non sono ancora documenti dell'archivio generale.":
    'No documents. This is where the deal’s papers go — company records, specifications, drafts — the ones that are not yet documents in the main archive.',
  "Righe dell'ordine": 'Order lines',
  "Sono i valori che l'ordine si porta dietro quando lo si crea.":
    'These are the values an order carries with it when it is created.',
  "Toglie l'articolo dal listino": 'Removes the item from the price list',
  "← Torna all'elenco": '← Back to the list',
  // ————————————————————————————————————————————————— etichette dei campi
  '+ Aggiungi': '+ Add',
  '+ E-mail': '+ E-mail',
  '+ Telefono': '+ Phone',
  Aggiungi: 'Add',
  'Aggiungi articolo': 'Add item',
  'Aggiungi documento': 'Add document',
  'Annulla selezione': 'Clear selection',
  Agente: 'Agent',
  Aliquota: 'Tax rate',
  Allegati: 'Attachments',
  Anagrafica: 'Record',
  'Anagrafiche di supporto': 'Supporting records',
  Applicate: 'Applied',
  'Apri e modifica i prezzi': 'Open and edit the prices',
  Archivia: 'Archive',
  'Articoli in archivio': 'Archived items',
  Attributi: 'Attributes',
  'Avvisi automatici': 'Automatic alerts',
  Budget: 'Budget',
  'CAP/ZIP': 'Postcode/ZIP',
  'Cerca per nome del listino o cliente': 'Search by price list name or customer',
  'Cerca per titolo, PO#, cliente, protocollo, nome del file':
    'Search by title, PO#, customer, protocol, file name',
  Chiaro: 'Light',
  Scuro: 'Dark',
  'Chiusura prevista': 'Expected closing',
  Classificazione: 'Classification',
  'Cod. destinazione': 'Destination code',
  'Codice BC — Inc': 'BC code — Inc',
  'Codice BC — SPA': 'BC code — SPA',
  'Codice GS1': 'GS1 code',
  'Codici GS1': 'GS1 codes',
  'Condizioni commerciali': 'Trading terms',
  Confezionamento: 'Packaging',
  'Configurazione pallet': 'Pallet configuration',
  Contatti: 'Contacts',
  'Costo DDP': 'DDP cost',
  Creati: 'Created',
  'Ctrl K': 'Ctrl K',
  'DDT USCITA MERCE 08/08/2026': 'DDT USCITA MERCE 08/08/2026',
  Dal: 'From',
  Denominazione: 'Name',
  'Descrizione estesa': 'Long description',
  'Dimensioni cartone': 'Case dimensions',
  'Documenti creati': 'Documents created',
  'Duplica il listino': 'Duplicate the price list',
  Esito: 'Outcome',
  Fatture: 'Invoices',
  'Fatture e documenti': 'Invoices and documents',
  'File da caricare': 'File to upload',
  Flusso: 'Feed',
  'Formati e pesi': 'Sizes and weights',
  Formato: 'Format',
  'GTIN-12': 'GTIN-12',
  'GTIN-13': 'GTIN-13',
  'GTIN-14 A': 'GTIN-14 A',
  'GTIN-14 A imballo': 'GTIN-14 A pack',
  'GTIN-14 B': 'GTIN-14 B',
  'GTIN-14 B imballo': 'GTIN-14 B pack',
  Identificazione: 'Identification',
  Imballo: 'Pack',
  'Importi e pagamento': 'Amounts and payment',
  'In corso': 'In progress',
  Indirizzi: 'Addresses',
  'Indirizzi e destinazioni': 'Addresses and destinations',
  'Indirizzi e-mail': 'E-mail addresses',
  Indirizzo: 'Address',
  'Indirizzo e-mail': 'E-mail address',
  'Inviata e-mail scheda tecnica prodotti': 'Product data sheet e-mail sent',
  'Legge da': 'Reads from',
  'Legge da Business Central e dice cosa cambierebbe, senza scrivere':
    'Reads from Business Central and says what would change, without writing',
  Lette: 'Read',
  'Letto fino a': 'Read up to',
  Linea: 'Line',
  'Listini da approvare': 'Price lists to approve',
  Listino: 'Price list',
  listini: 'price lists',
  Messaggio: 'Message',
  Modello: 'Template',
  'Navi e container': 'Vessels and containers',
  Nazione: 'Country',
  Nessuno: 'None',
  'Nessuno — prezzo a mano': 'None — price by hand',
  'Nota riservata': 'Private note',
  Note: 'Notes',
  Numero: 'Number',
  'Numero BC': 'BC number',
  'Numero di protocollo': 'Protocol number',
  'Numero di telefono': 'Phone number',
  'Nuova proposta': 'New proposal',
  'Nuova trattativa': 'New deal',
  'Nuovo contatto': 'New contact',
  'Nuovo documento': 'New document',
  'Nuovo indirizzo': 'New address',
  'Nuovo listino': 'New price list',
  Oggetto: 'Subject',
  Ora: 'Time',
  'Ordine creato': 'Order created',
  'Ordine tornato indietro di stato': 'Order moved back a state',
  'Ordini a cui associarlo': 'Orders to attach it to',
  'PIANO-SVILUPPO.md': 'PIANO-SVILUPPO.md',
  Paese: 'Country',
  'Parole chiave': 'Keywords',
  'Partita IVA': 'VAT number',
  Password: 'Password',
  'Ricordami per 30 giorni su questo computer': 'Remember me for 30 days on this computer',
  Persa: 'Lost',
  Vinta: 'Won',
  'Peso lordo cartone': 'Case gross weight',
  'Peso lordo pallet': 'Pallet gross weight',
  'Portalo allo stato': 'Move it to state',
  'Preferenze commerciali': 'Trading preferences',
  Prezzi: 'Prices',
  Prezzo: 'Price',
  'Prezzo EXW': 'EXW price',
  Problema: 'Problem',
  Prodotto: 'Product',
  Promo: 'Promo',
  'Proposta di listino sughi': 'Sauces price list proposal',
  'Proposta listino sughi': 'Sauces price list proposal',
  Proposte: 'Proposals',
  'Proposte di listino': 'Price list proposals',
  'Prov./Stato': 'Province/State',
  'Prova a vuoto': 'Dry run',
  'Quella predefinita': 'The default one',
  'Ragione sociale': 'Company name',
  Recapiti: 'Contact details',
  Resa: 'Incoterm',
  Riletto: 'Reviewed',
  Ripristina: 'Restore',
  Scarica: 'Download',
  Scartate: 'Discarded',
  Sconti: 'Discounts',
  Sconto: 'Discount',
  'Sconto globale (%)': 'Overall discount (%)',
  'Se il listino esiste già per il periodo prima, aprilo e usa Duplica: si porta dietro tutti i prezzi.':
    'If a price list already exists for the previous period, open it and use Duplicate: it carries every price over.',
  'Siti web': 'Websites',
  'Sito web': 'Website',
  'Stampa PDF': 'Print PDF',
  'Sto caricando…': 'Uploading…',
  Storico: 'History',
  Telefoni: 'Phones',
  Tipo: 'Type',
  Tipologia: 'Kind',
  'Torna alle colonne': 'Back to the columns',
  Trasporto: 'Transport',
  UdM: 'UoM',
  'Ultima volta andata bene': 'Last successful run',
  'Ultime esecuzioni': 'Latest runs',
  'Un file, più ordini': 'One file, several orders',
  'Valore pesato': 'Weighted value',
  Valuta: 'Currency',
  Variante: 'Variant',
  Venditore: 'Salesperson',
  'Volume cartone': 'Case volume',

  // ————————————————————————————————————————————————— parole minute, in minuscolo
  archiviata: 'archived',
  correzione: 'correction',
  'da guardare': 'to look at',
  'da incassare': 'to collect',
  'dal futuro': 'from the future',
  fallito: 'failed',
  'il prezzo si corregge cliccandolo': 'click the price to correct it',
  'in corso': 'in progress',
  'in vigore': 'in force',
  incassato: 'collected',
  mai: 'never',
  modifica: 'change',
  'modifiche non salvate': 'unsaved changes',
  nessuno: 'none',
  'niente ancora': 'nothing yet',
  parziale: 'partial',
  predefinito: 'default',
  principale: 'main',
  'ritardi ETA': 'ETA delays',
  riuscito: 'succeeded',
  saltato: 'skipped',
  salto: 'jump',
  scaduto: 'expired',
  'senza SKU': 'no SKU',
  'senza file': 'no file',
  'separate da virgola': 'comma separated',
  'sola lettura': 'read only',
  'stato indietro': 'state back',
  suo: 'their',
  'torna agli ordini': 'back to orders',
  '· destinazione': '· destination',
  '← Ordini': '← Orders',
  '← Torna agli articoli': '← Back to items',
  '← Torna agli ordini': '← Back to orders',
  '← Torna ai listini': '← Back to price lists',
  '← Torna alle trattative': '← Back to deals',
  '← Torna all’archivio': '← Back to the archive',
  // ————————————————————————————————————————————————— secondo giro
  ' — battono la riga': ' — they beat the line',
  ' — genera il codice GS1': ' — generate the GS1 code',
  ' — preso dal titolo, perché quello vero non dice niente':
    ' — taken from the title, because the real one says nothing',
  '1 è rimasta indietro:': '1 was left behind:',
  'Aggiungi un articolo al listino': 'Add an item to the price list',
  'Aggiungi un articolo alla proposta': 'Add an item to the proposal',
  'Come il sistema': 'Same as the system',
  'Con le archiviate': 'Archived included',
  'Crea il documento': 'Create the document',
  'Crea la trattativa': 'Create the deal',
  'Genera il listino ufficiale': 'Generate the official price list',
  'Già in questo listino': 'Already on this price list',
  'Gli articoli si aggiungono dopo, dalla scheda. Se il listino esiste già per il periodo precedente, aprilo e usa Duplica: si porta dietro tutti i prezzi.':
    'Items are added afterwards, from the price list itself. If a list already exists for the previous period, open it and use Duplicate: it carries every price over.',
  'Il caricamento non è riuscito.': 'The upload did not go through.',
  'Il file non si è potuto leggere.': 'The file could not be read.',
  'Il file si carica dopo, dalla scheda del documento: lì si vede quanto pesa e con che nome esce.':
    'The file is uploaded afterwards, from the document itself: there you see how big it is and the name it comes out with.',
  'La creazione non è riuscita.': 'It could not be created.',
  'La variante di questo articolo non prevede la generazione del codice.':
    'This item’s variant does not have a code to generate.',
  'La variante prevede il codice, ma non è ancora stato generato.':
    'The variant has a code, but it has not been generated yet.',
  'Le colonne sono già quelle dell’ultima importazione di questo cliente: controlla che i titoli non siano cambiati e vai avanti.':
    'The columns are already the ones from this customer’s last import: check that the headings have not changed and carry on.',
  'Le colonne sono state riconosciute dai titoli. Correggi quelle sbagliate: la prossima volta le ritrovi già compilate.':
    'The columns were recognised from the headings. Fix the wrong ones: next time you find them already filled in.',
  'Modifica il documento': 'Edit the document',
  'Modifica il listino': 'Edit the price list',
  'Modifica il prezzo': 'Edit the price',
  'Modifica la riga': 'Edit the line',
  'Modifica la trattativa': 'Edit the deal',
  'Modifica l’attività': 'Edit the activity',
  'Nave non indicata': 'No vessel given',
  'Nessun accesso': 'No access',
  'Nessun articolo con questi filtri.': 'No items match these filters.',
  'Nessun documento con questi filtri.': 'No documents match these filters.',
  'Nessun documento su questo ordine.': 'No documents on this order.',
  'Nessun listino con questi filtri.': 'No price lists match these filters.',
  'Nessuna riga conservata.': 'No rows kept.',
  'Nessuna trattativa con questi filtri.': 'No deals match these filters.',
  'Non c’è ancora niente qui.': 'There is nothing here yet.',
  'Non è stato possibile aprire la scheda.': 'The record could not be opened.',
  'Non è stato possibile aprire questo articolo.': 'This item could not be opened.',
  'Non è stato possibile aprire questo listino.': 'This price list could not be opened.',
  'Non è stato possibile aprire questo ordine.': 'This order could not be opened.',
  'Non è stato toccato niente.': 'Nothing was touched.',
  'Qualcosa non ha funzionato.': 'Something did not work.',
  'Qualità': 'Quality',
  'Questa sezione': 'This section',
  'Questo listino non ha un cliente, quindi non ci sono destinazioni da scegliere.':
    'This price list has no customer, so there are no destinations to choose from.',
  'Responsabile del personale': 'HR manager',
  'Sì, elimina': 'Yes, delete',
  'Tutte le destinazioni del cliente hanno già un prezzo su questa riga.':
    'Every destination of this customer already has a price on this line.',
  'Validità': 'Validity',
  'dopo gli articoli, con la duplicazione per il trimestre nuovo':
    'after items, with duplication for the new quarter',
  'dopo le anagrafiche, in sola lettura come oggi':
    'after the records, read-only as it is today',
  'il pezzo grosso: prima in lettura, poi la macchina a stati':
    'the big one: read-only first, then the state machine',
  'insieme agli articoli: una trentina di anagrafiche con la stessa forma':
    'together with items: about thirty records with the same shape',
  'insieme ai clienti: è lo stesso elenco con un filtro diverso':
    'together with customers: it is the same list with a different filter',
  'la prossima consegna: elenco con ricerca, viste salvate ed esportazione':
    'the next delivery: list with search, saved views and export',
  'non c’è nel foglio': 'not in the sheet',
  'ora si chiama': 'is now called',
  'verso la fine: il flusso va disegnato con il cliente':
    'towards the end: the flow has to be designed with the customer',
  'è diventato': 'has become',
  'Chiudi tutti': 'Close all',
  'Chiudo i {n} avvisi aperti?': 'Close all {n} open alerts?',
  'Chiuso un avviso.': 'One alert closed.',
  'Chiusi {n} avvisi.': '{n} alerts closed.',
  'Sì, chiudili': 'Yes, close them',
  'Restano a storico con la data di oggi. Se un arrivo si sposta ancora, l’avviso ricompare.':
    'They stay on record with today’s date. If an arrival moves again, the alert comes back.',
  'Da dove arriva': 'Where it came from',
  'Nessun tag definito per questa azienda: si creano dai Dati generici.':
    'No tags defined for this company: they are created from Generic data.',
  'Da soli, a orario': 'On their own, on a timetable',
  'orologio spento': 'clock off',
  Ogni: 'Every',
  Prossima: 'Next',
  Ultima: 'Last',
  'Come è andata': 'How it went',
  'Lancia ora': 'Run now',
  Accendi: 'Turn on',
  Spegni: 'Turn off',
  'appena possibile': 'as soon as possible',
  'mai partito': 'never run',
  bene: 'fine',
  'con scarti': 'with rejects',
  'non va': 'not working',
  'dal {quando}': 'since {quando}',
  'Righe scartate: da guardare.': 'Rejected rows: worth a look.',
  ore: 'hours',
  'un’ora': 'one hour',
  'un giorno': 'one day',
  'Nessuno riceverà gli avvisi: se un import si rompe non lo saprà nessuno. Gli indirizzi si mettono in Parametri.':
    'Nobody will get the alerts: if an import breaks, no one will know. The addresses go in Settings.',
  'Su questo servizio l’orologio non è acceso: gli orari qui sotto si possono impostare, ma niente parte da solo.':
    'The clock is not running on this service: the timetables below can be set, but nothing starts on its own.',
  'Avvisi degli import': 'Import alerts',
  'A chi scrivere quando un import si rompe': 'Who to write to when an import breaks',
  'Più indirizzi separati da virgola. Lasciandolo vuoto non viene avvisato nessuno.':
    'Several addresses separated by commas. Leave it empty and nobody is notified.',
  'Parte un messaggio quando un import smette di funzionare, e uno quando riprende. Non uno per ogni tentativo: se resta rotto, si tace finché non cambia qualcosa. Nel v2 gli articoli della Inc erano fermi da due anni e non lo sapeva nessuno.':
    'One message goes out when an import stops working, and one when it starts again. Not one per attempt: while it stays broken, it keeps quiet until something changes. In v2 the Inc items had been stuck for two years and nobody knew.',
  'Arrivo stimato': 'Estimated arrival',
  'Avanzo…': 'Advancing…',
  'Aziende in cui lavora': 'Companies they work in',
  'Caricalo dalla scheda «Fatture e documenti», poi torna qui.':
    'Upload it from the “Invoices and documents” tab, then come back here.',
  'Confermando, l’ordine parte da solo: i dati a C&L per il DAU e, se il vettore è un altro, al vettore. Solo per i clienti che hanno acceso l’invio ai vettori.':
    'On confirming, the order goes out on its own: the data to C&L for the customs document and, if the carrier is another one, to the carrier. Only for customers who have turned on sending to carriers.',
  'Consegna richiesta aggiornata': 'Requested delivery updated',
  'Consegna richiesta dal cliente': 'Delivery requested by the customer',
  'Consegna stimata': 'Estimated delivery',
  'Container / spedizione': 'Container / shipment',
  Correggi: 'Edit',
  'Correggi la testata': 'Edit the header',
  'Data di arrivo': 'Arrival date',
  'Data di consegna': 'Delivery date',
  'Data fattura Inc': 'Inc invoice date',
  'Data fattura SPA': 'SPA invoice date',
  'Gli amministratori entrano in tutte le aziende.': 'Administrators can enter every company.',
  'Le righe non si aggiungono e non si cambiano più: sono già andate a Business Central. Si possono ancora togliere fino allo stato 3.':
    'Lines can no longer be added or changed: they have already gone to Business Central. They can still be removed up to state 3.',
  'Le righe non si toccano più: la merce è partita.': 'Lines can no longer be touched: the goods have shipped.',
  'Manca:': 'Missing:',
  'Merce partita il': 'Goods shipped on',
  'Merce pronta il': 'Goods ready on',
  Nave: 'Ship',
  'Note di spedizione': 'Shipping notes',
  'Numero fattura Inc': 'Inc invoice number',
  'Numero fattura SPA': 'SPA invoice number',
  'Partenza stimata': 'Estimated departure',
  'Per questo passaggio serve il': 'This step needs the',
  'Questo cliente non ha un sezionale: impostalo nelle sue «Preferenze commerciali».':
    'This customer has no sectional: set it in their “Commercial preferences”.',
  'Scegli dove andare': 'Choose where to go',
  'Scegline almeno una: senza, entra e non trova niente.':
    'Choose at least one: without it, they log in and find nothing.',
  'Scegli il livello: senza, non entra.': 'Choose the access level: without it, they cannot log in.',
  'Sconto %': 'Discount %',
  'Si aprono solo i campi che in questo stato si possono cambiare. Salvare non manda niente a Business Central né ai vettori.':
    'Only the fields that can change in this state are open. Saving sends nothing to Business Central or to the carriers.',
  'Sì, vai avanti': 'Yes, go ahead',
  Vettore: 'Carrier',
  'chiede:': 'needs:',
  'e il': 'and the',
  'non chiede niente': 'needs nothing',
  'quello del cliente': 'the customer’s',

  // Business Central, nella scheda dell'ordine
  'Invii a Business Central': 'Sent to Business Central',
  'Da questo CRM non è ancora partito niente per Business Central.':
    'Nothing has been sent to Business Central from this CRM yet.',
  'Fino al passaggio partono solo gli ordini dei clienti di prova, con il numero spostato.':
    'Until the switch-over only test customers’ orders are sent, with a shifted number.',
  'Inseriscilo lo stesso': 'Insert it anyway',
  'Manda l’aggiornamento': 'Send update',
  'Manda l’inserimento': 'Send insert',
  'cosa è partito': 'what was sent',
  'in prova': 'test mode',
  'invio acceso': 'sending on',
  'invio spento': 'sending off',
  inserimento: 'insert',
  aggiornamento: 'update',
  accettate: 'accepted',
  prova: 'test',
  'cambio di stato': 'state change',
  'a mano': 'by hand',
  '«Stato 2» di massa': 'bulk «State 2»',
  'invio al vettore': 'send to carrier',
  'invio al vettore di massa': 'bulk send to carrier',
  'tracking C&L': 'C&L tracking',
  'movimento Interglobo': 'Interglobo movement',
  '«Aggiorna gli stati» da una data': '«Update the states» from a date',
  accettata: 'accepted',
  rifiutata: 'refused',
  'non arrivata': 'not delivered',
  'non partita': 'not sent',

  // Business Central, «Aggiorna gli stati» nelle Integrazioni
  'Aggiorna gli stati in Business Central': 'Update the states in Business Central',
  'Rimanda a Business Central stato, date, nave, container e DAU degli ordini della SPA, dalla data dell’ordine scelta in poi. Serve a rimetterlo in pari quando il CRM è andato avanti da solo. Ogni ordine sono una decina di chiamate: un mese di ordini richiede qualche ora, e il lavoro continua anche a pagina chiusa.':
    'Sends Business Central the state, dates, vessel, container and DAU of the SPA orders from the chosen order date onwards. It brings it back in line when the CRM has moved on without it. Each order is about ten calls: a month of orders takes a few hours, and the job keeps going even with the page closed.',
  '{fatti} ordini su {totale}': '{fatti} orders of {totale}',
  '{ok} accettati, {problemi} con problemi': '{ok} accepted, {problemi} with problems',
  'dal {data}, partito {quando}': 'from {data}, started {quando}',
  'Si ferma dopo questo ordine…': 'Stopping after this order…',
  Ferma: 'Stop',
  'Su questo server l’invio a Business Central è spento: non partirebbe niente.':
    'Sending to Business Central is off on this server: nothing would go out.',
  'Si aggiornano solo gli ordini della SPA: gli stati della Inc in Business Central li porta avanti chi ci lavora.':
    'Only SPA orders are updated: the Inc states in Business Central are kept by the people who work in it.',
  'Ordini con data dal': 'Orders dated from',
  'Nessun ordine da mandare.': 'No orders to send.',
  'Partirebbero {n} ordini.': '{n} orders would be sent.',
  Aggiorna: 'Update',
  'Sì, manda {n} ordini': 'Yes, send {n} orders',
  'Aggiornati su Business Central: {n} ordini': 'Updated in Business Central: {n} orders',
  ', {n} con problemi (si vedono nelle righe dell’esecuzione)':
    ', {n} with problems (see the rows of the run)',
  // correzioni del collaudo, 24 ottobre sera
  'Scrivili lo stesso': 'Write them anyway',
  'Codice uguale a quello di un altro articolo:': 'Same code as another item:',
  'È quello del cliente: decide a quale società di Business Central vanno gli ordini.': 'It is the customer’s: it decides which Business Central company the orders go to.',
  'La modifica non è stata salvata: riprova.': 'The change was not saved: try again.',
  'L’operazione non è riuscita: riprova.': 'That did not work: try again.',
  'L’elenco non è arrivato: riprova fra un momento.': 'The list did not load: try again in a moment.',
  'Il servizio non risponde: la tua sessione è a posto, non serve rientrare.': 'The service is not answering: your session is fine, no need to sign in again.',
  'Riprova': 'Try again',
  '{vettore} non indica la nave (DEFAULT): va bene così, o scrivila se la sai.':
    '{vettore} does not give the vessel (DEFAULT): that is fine, or type it if you know it.',
  '{vettore} non indica il container (DEFAULT): va bene così, o scrivilo se lo sai.':
    '{vettore} does not give the container (DEFAULT): that is fine, or type it if you know it.',
  'Il vettore': 'The carrier',

  // ————————————————————————————————————————————————— da confermare (produzione)
  Produzione: 'Production',
  'Da confermare': 'To confirm',
  'Gli ordini da portare allo stato 2': 'Orders to move to state 2',
  'Gli ordini allo stato 1: controlla gli articoli e portali allo stato 2. Se qualcosa non va, avvisa chi ha inserito l’ordine prima di confermarlo.':
    'Orders in state 1: check the items and move them to state 2. If something is wrong, tell whoever entered the order before confirming it.',
  Confermati: 'Confirmed',
  'Seleziona tutti': 'Select all',
  '{n} selezionati': '{n} selected',
  'Porta allo stato 2': 'Move to state 2',
  'Porto allo stato 2 l’ordine selezionato?': 'Move the selected order to state 2?',
  'Porto allo stato 2 i {n} ordini selezionati?': 'Move the {n} selected orders to state 2?',
  'Sì, porta allo stato 2': 'Yes, move to state 2',
  '1 ordine portato allo stato 2.': '1 order moved to state 2.',
  '{n} ordini portati allo stato 2.': '{n} orders moved to state 2.',
  'Nessun ordine da confermare.': 'No orders to confirm.',
  'Nessun ordine confermato.': 'No confirmed orders.',
  'Nessuna riga.': 'No lines.',
  'Seleziona l’ordine {numero}': 'Select order {numero}',
  'Ultima modifica: {quando}': 'Last changed: {quando}',
  'Cerca per PO#, cliente, destinazione': 'Search by PO#, customer, destination',

  // ————————————————————————————————————————————————— esporta gli ordini
  'Esporta in Excel': 'Export to Excel',
  'Esporta in CSV': 'Export to CSV',
  '{n} ordini, con i filtri di adesso': '{n} orders, with the current filters',
  'Un ordine, con i filtri di adesso': 'One order, with the current filters',
  'Le scelte restano tue: la prossima volta la finestra si apre così.':
    'Your choices are kept: next time this window opens the same way.',
  Esporta: 'Export',
  'Scegli almeno una colonna dell’ordine.': 'Choose at least one order column.',
  'Scegli almeno una colonna degli articoli, oppure togli «Esporta anche gli articoli».':
    'Choose at least one item column, or untick “Export the items too”.',
  'Intestazione delle colonne': 'Column headers',
  'in italiano': 'in Italian',
  'in inglese': 'in English',
  'Nella stessa lingua anche gli stati, il pagamento e le date; nomi, descrizioni e note restano come sono.':
    'Statuses, payment and dates follow the same language; names, descriptions and notes stay as they are.',
  'Esporta anche gli articoli': 'Export the items too',
  'Una riga per ogni articolo, con i dati dell’ordine ripetuti su ognuna. Per le somme usa «Totale riga»: il totale dell’ordine si ripete su ogni riga.':
    'One row per item, with the order details repeated on each. For sums use “Line total”: the order total repeats on every row.',
  'Una riga per ogni ordine.': 'One row per order.',
  'Colonne dell’ordine': 'Order columns',
  'Colonne dell’articolo': 'Item columns',
  '{n} di {m}': '{n} of {m}',

  // ————————————————————————————————————————————————— frasi che erano fuori da t()
  // (26 ottobre 2026: etichette dei campi, filtri, riepiloghi, finestre)
  // etichette dei campi nelle schede (Dato, CampoBc)
  'Alias': 'Alias',
  'Articoli a listino': 'Items on the price list',
  'CAP o ZIP': 'Postcode or ZIP',
  'Caricato il': 'Uploaded on',
  'Codice destinazione': 'Destination code',
  'Codice in BC — Inc': 'BC code — Inc',
  'Codice in BC — SPA': 'BC code — SPA',
  'Cognome': 'Surname',
  'Con prezzi per destinazione': 'With prices per destination',
  'Consegna': 'Delivery',
  'Data dell\'ordine': 'Order date',
  'Dimensione': 'Size',
  'Esce con questo nome': 'Downloads with this name',
  'Fattura Inc': 'Inc invoice',
  'Fattura SPA': 'SPA invoice',
  'Imponibile': 'Taxable amount',
  'Importo incassato': 'Amount collected',
  'Imposta': 'Tax',
  'Incassato il': 'Collected on',
  'Indirizzo — seconda riga': 'Address — second line',
  'Informazioni agente': 'Agent information',
  'Inviato al vettore': 'Sent to the carrier',
  'Merce partita': 'Goods shipped',
  'Merce pronta': 'Goods ready',
  'Nome a archivio': 'Name in the archive',
  'Numero d\'ordine del cliente': 'Customer order number',
  'Numero in Business Central': 'Business Central number',
  'Ordine di vendita': 'Sales order',
  'Ordini che lo contengono': 'Orders containing it',
  'Penali': 'Penalties',
  'Presa in carico': 'Acknowledged',
  'Probabilità di chiusura': 'Closing probability',
  'Protocollo': 'Protocol',
  'Provincia o stato': 'Province or state',
  'Quantità totale': 'Total quantity',
  'Riferimento incrociato': 'Cross reference',
  'Ruolo': 'Role',
  'SKU': 'SKU',
  'Scadenza prevista': 'Expected due date',
  'Sconto globale': 'Overall discount',
  'Sigillo': 'Seal',
  'Ufficio o sede': 'Office or site',
  'Ultimo ordine': 'Last order',
  'Valore atteso': 'Expected value',
  'Venduto da': 'Sold by',
  // filtri (le etichette arrivano dal servizio)
  'Approvvigionamento automatico': 'Automatic supply',
  'Articolo (numero interno)': 'Item (internal number)',
  'Categoria': 'Category',
  'Categoria 2° livello': 'Second-level category',
  'Chiusura prevista entro il': 'Expected closing by',
  'Codice Business Central': 'Business Central code',
  'Consegna richiesta al': 'Requested delivery to',
  'Consegna richiesta dal': 'Requested delivery from',
  'Container': 'Container',
  'Contiene lo SKU': 'Contains the SKU',
  'Contiene l’articolo': 'Contains the item',
  'E-mail': 'E-mail',
  'Formato del file': 'File format',
  'Ha un codice GS1': 'Has a GS1 code',
  'In ritardo sulla consegna': 'Late on delivery',
  'Invio dati ai vettori': 'Data sent to carriers',
  'Numero fattura': 'Invoice number',
  'Numero ordine (PO#)': 'Order number (PO#)',
  'Ordine al': 'Order to',
  'Ordine dal': 'Order from',
  'Pagamento anticipato': 'Prepayment',
  'Probabilità almeno (%)': 'Probability at least (%)',
  'Protocollo del documento': 'Document protocol',
  'Protocollo dell’ordine': 'Order protocol',
  'SKU articolo': 'Item SKU',
  'Senza file caricato': 'No file uploaded',
  'Stato del pagamento': 'Payment status',
  'Telefono': 'Phone',
  'assente': 'missing',
  'in vigore oggi': 'valid today',
  'non ancora cominciati': 'not started yet',
  'non pagato': 'unpaid',
  'pagato': 'paid',
  'presente': 'present',
  'scaduti': 'expired',
  'tutti': 'all',
  '{n} scelti': '{n} chosen',
  'Togli il filtro {nome}': 'Remove the filter {nome}',
  // destinazioni e Business Central (27 ottobre 2026)
  'Questa destinazione non c’è nella Business Central della Inc, dove va l’ordine: lì non la troverebbe. Va creata in BC.':
    'This destination is not in the Inc’s Business Central, where the order goes: it would not be found there. It has to be created in BC.',
  'Questa destinazione non c’è nella Business Central della SPA, dove va l’ordine: lì non la troverebbe. Va creata in BC.':
    'This destination is not in the SPA’s Business Central, where the order goes: it would not be found there. It has to be created in BC.',
  'Una destinazione di questo cliente non è nella Business Central della Inc, e qui non si vede.':
    'One destination of this customer is not in the Inc’s Business Central, so it is not shown here.',
  '{n} destinazioni di questo cliente non sono nella Business Central della Inc, e qui non si vedono.':
    '{n} destinations of this customer are not in the Inc’s Business Central, so they are not shown here.',
  'del cliente': 'customer’s own',
  'Codice per BC': 'Code for BC',
  'Nessuna: in BC va l’indirizzo del cliente': 'None: BC uses the customer’s address',
  'Questo cliente non ha indirizzi: l’ordine nasce senza destinazione, e Business Central spedisce all’indirizzo del cliente.':
    'This customer has no addresses: the order is created without a ship-to address, and Business Central ships to the customer’s address.',
  'in BC è l’indirizzo del cliente': 'in BC it is the customer’s own address',
  // elenchi: riepiloghi, piè di pagina, ricerche senza risultati
  '{n} in archivio': '{n} on file',
  '{n} in archivio, archiviate comprese': '{n} on file, archived included',
  '{n} articoli · arrivano da Business Central': '{n} items · they come from Business Central',
  '{n} articoli, archiviati compresi · arrivano da Business Central':
    '{n} items, archived included · they come from Business Central',
  '{n} documenti': '{n} documents',
  '{n} documenti, archiviati compresi': '{n} documents, archived included',
  '{n} listini': '{n} price lists',
  '{n} listini, archiviati compresi': '{n} price lists, archived included',
  '{n} trattative': '{n} deals',
  '{n} trattative, archiviate comprese': '{n} deals, archived included',
  'documenti': 'documents',
  'trattative': 'deals',
  'Nessun risultato per «{cerca}».': 'No results for “{cerca}”.',
  'Nessun articolo per «{cerca}».': 'No items for “{cerca}”.',
  'Nessun documento per «{cerca}».': 'No documents for “{cerca}”.',
  'Nessun listino per «{cerca}».': 'No price lists for “{cerca}”.',
  'Nessuna trattativa per «{cerca}».': 'No deals for “{cerca}”.',
  'Pagina {n} di {m}': 'Page {n} of {m}',
  '{primo}–{ultimo} di {totale} {nome}': '{primo}–{ultimo} of {totale} {nome}',
  'Questa pagina è oltre la fine: {totale} {nome} in {pagine} pagine':
    'This page is past the end: {totale} {nome} in {pagine} pages',
  '{n} righe': '{n} rows',
  'Elimina la vista {nome}': 'Delete the view {nome}',
  'Articolo {n}': 'Item {n}',
  '{n} in tutto': '{n} in all',
  'gli ultimi {quanti} di {totale}': 'the latest {quanti} of {totale}',
  'Vedi tutti i {n} ordini →': 'See all {n} orders →',
  // azioni di massa
  '1 riga selezionata': '1 row selected',
  '{n} righe selezionate': '{n} rows selected',
  '1 riga sistemata.': '1 row done.',
  '{n} righe sistemate.': '{n} rows done.',
  '{n} sono rimaste indietro:': '{n} were left behind:',
  'Al massimo {n} per volta.': 'At most {n} at a time.',
  'Elimino {n} {cosa}?': 'Delete {n} {cosa}?',
  'Elimino…': 'Deleting…',
  'anagrafica': 'record',
  'anagrafiche': 'records',
  'articolo': 'item',
  'documento': 'document',
  'listino': 'price list',
  'ordine': 'order',
  'trattativa': 'deal',
  // schede: ordine, cliente, articolo, documento, listino, trattativa
  '1 riga': '1 line',
  'totale': 'total',
  'e': 'and',
  'gestita in {aziende}': 'handled in {aziende}',
  'venduto da {aziende}': 'sold by {aziende}',
  'in BC SPA': 'in BC SPA',
  'in BC Inc': 'in BC Inc',
  'no': 'no',
  'protocollo': 'protocol',
  'rif. {codice}': 'ref. {codice}',
  'bolla {numero} del {data}': 'customs entry {numero} of {data}',
  'partenza {data}': 'departure {data}',
  'arrivo {data}': 'arrival {data}',
  'consegna {data}': 'delivery {data}',
  'ultimo aggiornamento dal vettore: {quando}': 'last update from the carrier: {quando}',
  'le ultime {n}': 'the latest {n}',
  'Destinazione {n}': 'Destination {n}',
  'questa destinazione': 'this destination',
  'Togli il prezzo per {dove}': 'Remove the price for {dove}',
  'Sconto {n} (%)': 'Discount {n} (%)',
  'chiusura prevista {data}': 'expected closing {data}',
  '1 articolo': '1 item',
  '{n} articoli': '{n} items',
  'Approvata da {chi} il {quando}.': 'Approved by {chi} on {quando}.',
  'qualcuno': 'someone',
  'pesato': 'weighted',
  'Da questa proposta è nato il listino': 'This proposal produced the price list',
  'Questo file è anche di un altro documento: è stato caricato una volta sola per più ordini. Caricarne un altro qui lascia l’altro sul file di prima.':
    'This file also belongs to another document: it was uploaded once for several orders. Uploading another one here leaves the other on the previous file.',
  'Questo file è anche di altri {n} documenti: è stato caricato una volta sola per più ordini. Caricarne un altro qui lascia gli altri sul file di prima.':
    'This file also belongs to {n} other documents: it was uploaded once for several orders. Uploading another one here leaves the others on the previous file.',
  // finestre
  'Adesso è: {stato}': 'Now it is: {stato}',
  'Modifica {cosa}': 'Edit {cosa}',
  'Nuovo {cosa}': 'New {cosa}',
  'Modifica · {nome}': 'Edit · {nome}',
  'Nuovo · {nome}': 'New · {nome}',
  'sede': 'head office',
  'Crea 1 documento': 'Create 1 document',
  'Crea i documenti': 'Create the documents',
  'Crea {n} documenti': 'Create {n} documents',
  'Questi numeri non corrispondono a nessun ordine e sono rimasti fuori:':
    'These numbers match no order and were left out:',
  'Prezzo dedicato a questa destinazione, non quello di riga: viene dal listino «{listino}».':
    'Price dedicated to this destination, not the line price: it comes from the price list “{listino}”.',
  'Prezzo di listino, da «{listino}».': 'Price list price, from “{listino}”.',
  '— a ognuno viene aggiunto in coda il suo PO#': '— each gets its PO# added at the end',
  '— anche un lead o un prospect: si sta ancora trattando':
    '— a lead or a prospect too: the deal is still open',
  '— cerca per descrizione, SKU o numero BC': '— search by description, SKU or BC number',
  '— cerca per nome, codice BC o partita IVA': '— search by name, BC code or VAT number',
  '— non esce nella proposta mandata al cliente': '— not shown in the proposal sent to the customer',
  '— scrivi il numero d’ordine del cliente e premi Invio': '— type the customer order number and press Enter',
  '— valore atteso': '— expected value',
  '— è anche il nome con cui esce il file, quando quello vero non dice niente':
    '— it is also the name the file downloads with, when the real one says nothing',
  '{n} car.': '{n} chars',
  '{n} di troppo': '{n} too many',
  'Business Central rifiuta gli ordini con questo campo più lungo di {n} caratteri.':
    'Business Central rejects orders with this field longer than {n} characters.',
  '«{estensione}» non è tra i formati ammessi: {ammessi}.':
    '“{estensione}” is not among the allowed formats: {ammessi}.',
  'senza estensione': 'no extension',
  'Il file pesa {peso}: il limite è {limite}.': 'The file is {peso}: the limit is {limite}.',
  'qualsiasi formato': 'any format',
  // import da Excel
  '{n} ordini creati per {cliente}': '{n} orders created for {cliente}',
  '{n} voci': '{n} entries',
  'riga {n}': 'row {n}',
  '{righe} righe · {colonne} colonne': '{righe} rows · {colonne} columns',
  'Senza queste non si può andare avanti: {campi}.': 'You cannot go on without these: {campi}.',
  '— manca —': '— missing —',
  '1 stabilimento da associare': '1 plant to match',
  '{n} stabilimenti da associare': '{n} plants to match',
  'Questi nomi non corrispondono a nessuna destinazione di {cliente}. Dillo una volta: la prossima volta li riconosce da solo.':
    'These names match no destination of {cliente}. Say it once: next time it recognises them by itself.',
  '1 riga nel foglio': '1 row in the sheet',
  '{n} righe nel foglio': '{n} rows in the sheet',
  'Nel foglio c’era {prezzo}': 'The sheet said {prezzo}',
  'Crea 1 ordine': 'Create 1 order',
  'Crea {n} ordini': 'Create {n} orders',
  'Da questo foglio non nasce nessun ordine nuovo. Controlla il foglio scelto e le colonne, oppure':
    'This sheet produces no new order. Check the chosen sheet and the columns, or',
  // integrazioni e avvisi
  'Import non riuscito: {errore}': 'Import failed: {errore}',
  'Lette {lette} righe: {create} create, {aggiornate} aggiornate, {apposto} già a posto':
    'Read {lette} rows: {create} created, {aggiornate} updated, {apposto} already up to date',
  ', {n} scartate': ', {n} rejected',
  '(prova a vuoto: non è stato scritto niente)': '(dry run: nothing was written)',
  'Ultimo tentativo fallito {quando}.': 'Last attempt failed {quando}.',
  'Leggo…': 'Reading…',
  'Importa adesso': 'Import now',
  'Scarico…': 'Downloading…',
  'Scarica adesso': 'Download now',
  'Scarico non riuscito: {errore}': 'Download failed: {errore}',
  'Niente di nuovo da scaricare.': 'Nothing new to download.',
  '{lette} documenti: {applicati} applicati, {visti} già visti':
    '{lette} documents: {applicati} applied, {visti} already seen',
  ', {n} in attesa del loro ordine': ', {n} waiting for their order',
  ', {n} scartati': ', {n} rejected',
  '1 avviso di arrivo spostato': '1 arrival-moved alert',
  '{n} avvisi di arrivo spostato': '{n} arrival-moved alerts',
  ', {n} notificati': ', {n} notified',
  'adesso': 'just now',
  '{n} minuti fa': '{n} minutes ago',
  'un’ora fa': 'an hour ago',
  '{n} ore fa': '{n} hours ago',
  'ieri': 'yesterday',
  '{n} giorni fa': '{n} days ago',
  'un mese fa': 'a month ago',
  '{n} mesi fa': '{n} months ago',
  '{n} anni fa': '{n} years ago',
  'Arrivo spostato': 'Arrival moved',
  'Stato tornato indietro': 'Status went back',
  'Niente da guardare.': 'Nothing to look at.',
  '1 avviso aperto': '1 open alert',
  ': qui i primi {n}': ': the first {n} here',
  'Ultima volta {quando}': 'Last time {quando}',
  '{n} testi non sono ancora stati riletti da una persona. Quelli inglesi del vecchio programma sono passati da Google Translate — «Employment Desidered» viene da lì.':
    '{n} texts have not been checked by a person yet. The English ones of the old program went through Google Translate — “Employment Desidered” comes from there.',
  // pagina in costruzione
  'dopo gli ordini, insieme all’archivio dei file': 'after the orders, together with the file archive',
  'quando entra in funzione l’agente Business Central': 'when the Business Central agent starts working',
  'in programma nelle prossime consegne': 'planned for the next releases',
  'Il programma completo, tappa per tappa, è nel file': 'The full plan, step by step, is in the file',
};
